
const messages = {
  headerTitles: {
    opportunityCreator: 'Opportunity Creator',
    opportunityNotifications: 'Opportunity Notifications'
  },
  login:{
    headerTitle: 'UKG Connect',
    headerSubtitle: 'Enter your UKG username and password to connect to UKG'
  },
  company: {
    title: 'Select a Company'
  },
  opportunities: 'Opportunities',
  createOpportunity: 'Create Opportunity',
  opportunityCreation: 'Opportunity Creation',
  opportunitySubTitle: 'Expand the opportunities to view job titles and processes, or download the report in Excel format.',
  createOpportunitySubTitle: 'Select a job title and a process to create an opportunity.',
  publish: 'Publish',
  feedback:{
    title: 'Feedback',
    ratingTitle:'Please rate your experience on this page',
    selectTitle: 'What is the nature of your feedback?',
    feedbackTextfieldTitle:'What would you like to share with us?',
    emailTitle: 'Please leave your email if you would like to be contacted.'
  },
  //Opportunities Notifications 
  toastMessages: {
    title: 'Success! Your notification preferences have been saved.',
    subTitle: 'You\'ll receive your first report tomorrow morning, and we\'ll continue to send updates as per your selection. Keep an eye on your inbox!',
    subTitleNone: 'You will no longer receive notifications.'
  }
}

export default messages;